import type { TableTone } from "@akuna/ui";
import type { ScheduleReservation } from "./scheduleModel";

const STATUS_TONE: Record<ScheduleReservation["status"], TableTone> = {
  reserved: "neutral",
  checked_in: "blue",
  checked_out: "green",
  cancelled: "red",
  no_show: "neutral",
};

export const getScheduleStatusTone = (status: ScheduleReservation["status"]): TableTone => STATUS_TONE[status];
